//* Libraries imports
import { useNavigate, useParams } from 'react-router-dom';

//* Hooks imports
import { useGetProcessById } from '../../../../hooks/queries/process/use-get-process';

//* Components imports
import { ProcessSkeleton } from '../../../../skeleton/ProcessSkeleton/process-skeleton';
import { ViewHeaderProcess } from './view-header-process';
import { ViewListCard } from './view-list-card';
import { ErrorMessages } from '../../../../component/common/ErrorMessages';

export function Content() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const processId = id ? parseInt(id) : 0;
  const processQuery = useGetProcessById(processId);
  const { isLoading, isError, data: processResponse } = processQuery;

  if (!processId) {
    navigate("/process");
    return null;
  }

  const handleBack = () => {
    navigate("/process");
  };

  const renderMainContent = () => {
    const process = processResponse!.data!;
    return (
      <div className="w-100">
        <ViewHeaderProcess
          processName={process?.name}
          handleBack={handleBack}
          isOnline={process?.online}
          startDate={process?.start?.human?.date}
          endDate={process?.end?.human?.date}
          collegeName={process?.college?.name}
        />

        <div className="d-flex justify-content-center">
          <ViewListCard 
            processId={processId} 
            testId={process.test?.[0]?.id || 0} 
          />
        </div>
      </div>
    );
  };
  return isLoading ? (
    <ProcessSkeleton />
  ) : isError || !processResponse?.success || !processResponse?.data ? (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <ErrorMessages
        messages={[
          processResponse?.message ||
            "Não foi possível carregar os detalhes do processo.",
        ]}
        clearErrors={handleBack}
      />
    </div>
  ) : (
    renderMainContent()
  );
}